import { createScreenStyles } from '../../theme/styles';
import { OPERATIONS_API_BASE } from '../../config/api';

import React, { useState, useEffect } from "react";
import {
  View,
  ScrollView,
  KeyboardAvoidingView,
  Text,
  StyleSheet,
  TouchableHighlight,
  Dimensions,
  ActivityIndicator,
  TextInput,
  Alert,
  Platform
} from "react-native";

import AsyncStorage from "@react-native-async-storage/async-storage";
import { Ionicons } from '@expo/vector-icons';
import { Entypo } from '@expo/vector-icons';
const screenWidth = Math.round(Dimensions.get("window").width);
const screenHeight = Math.round(Dimensions.get("window").height);
export function isIphoneX() {
  return Platform.OS === "ios" && screenHeight >= 812;
}

export function isAndroid() {
  return Platform.OS !== "ios";
}

export default function despesa({ route, navigation }) {
  const [despesaId, setDespesaId ] = useState(route.params.despesaId)
  const [userid, setUserid] = useState("");
  const [apprdesp, setApprdesp] = useState(false);
  const [usernome, setUsernome] = useState("");
  const [nomerequester, setNomerequester] = useState("");
  const [nomeaprovador, setNomeaprovador] = useState("");  
  const [loading, setLoading] = useState(false);
  const [numero, setNumero] = useState("");
  const [status, setStatus] = useState(0);
  const [dataEntrada, setDataEntrada] = useState("");
  const [dataEntradaRaw, setDataEntradaRaw] = useState("");
  const [itens, setItens] = useState([]);
  const [itensSum, setItensSum] = useState(0);
  const [comments, setComments] = useState("");
  const [commaprovador, setCommaprovador] = useState("");
  const [motivo, setMotivo] = useState("");
  const [rejectAction, setRejectAction] = useState(false);

  async function getStorageValue() {
    setUserid(await AsyncStorage.getItem("sfuserid"));
    setUsernome(await AsyncStorage.getItem("sfusernome"));
    setApprdesp(await AsyncStorage.getItem("sfdespappr"));
  }

  async function loadItens(despesagoBack) {
    let response;
    if(despesagoBack){
      setDespesaId(despesagoBack)
      response = await fetch(
        `${OPERATIONS_API_BASE}/despesaItem/despesa/` + despesagoBack
      );
    } else {
      if(despesaId === 0){        
        setLoading(false);
        return;
      } else {
        response = await fetch(
          `${OPERATIONS_API_BASE}/despesaItem/despesa/` + despesaId
        );
      }  
    }
 
    const data = await response.json();
    setItens(data);

    const sum = data.reduce((accumulator, object) => {
      return accumulator + object.valor;
    }, 0);
    setItensSum(sum);

    setLoading(false);
  }

  
  async function loadHeader() {
    if(despesaId === 0){
      setStatus(0);
      const dataEnt = new Date();
      let dataFormatada = ((dataEnt.getDate() )) + "/" + ((dataEnt.getMonth() + 1)) + "/" + dataEnt.getFullYear(); 
      setDataEntrada(dataFormatada);
      setDataEntradaRaw(dataEnt);
      return;
    };
    
    const response = await fetch(
      `${OPERATIONS_API_BASE}/despesa/` + despesaId
    );

    const data = await response.json();
    if(data.length > 0) {
      setNumero(data[0].numero);
      setStatus(data[0].status);
      setComments(data[0].obsgeral);
      setCommaprovador(data[0].commaprovador);
      setDataEntrada(data[0].dataentrada.substring(0, 10));
      setDataEntradaRaw(data[0].dataentrada);
      setNomeaprovador(data[0].nomeaprovador);
      setNomerequester(data[0].nomerequester);
    }


    
  }


  async function saveOnly(redirect, submit) {
    setLoading(true);
    let responseApi;
    if(despesaId === 0){
    responseApi = await fetch(
        `${OPERATIONS_API_BASE}/despesa/`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          dataentrada: dataEntradaRaw,
          status: "0",
          idrequester: userid,
          nomerequester: usernome,
          idaprovador: "",
          nomeaprovador: "",
          obsgeral: comments
        }),
    });
    
    const dataPost1 = await responseApi.json();
    setLoading(false);
    if(redirect){
      navigation.navigate("Home");
    } else {
      return dataPost1.docDespesaId;
    }
  } else {
    responseApi = await fetch(
      `${OPERATIONS_API_BASE}/despesa/` + despesaId, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        idaprovador: "",
        nomeaprovador: "",
        obsgeral: comments
      }),
  });

  if (submit) {

    if (Platform.OS === 'web') {

      const confirmou = window.confirm(
        'Você confirma o envio das Despesas para aprovação ?'
      );

      if (confirmou) {
        await confirmSubmit();
      }

    } else {

      Alert.alert(
        'Atenção',
        'Você confirma o envio das Despesas para aprovação ?',
        [
          {
            text: 'Sim',
            onPress: () => confirmSubmit()
          },
          {
            text: 'Cancelar'
          }
        ],
        {
          cancelable: true
        }
      );

    }
  }

    setLoading(false);
    if(redirect){
      navigation.navigate("Home");
    } else {
      return despesaId;
    }
  }
    
  }

  function removeItem(id) {

    if (Platform.OS === 'web') {

      const confirmou = window.confirm(
        'Você confirma a remoção da despesa?'
      );

      if (confirmou) {
        confirmRemoveItem(id);
      }

    } else {

      Alert.alert(
        'Atenção',
        'Você confirma a remoção da despesa?',
        [
          {
            text: 'Sim',
            onPress: () => confirmRemoveItem(id)
          },
          {
            text: 'Cancelar',
            style: 'cancel'
          }
        ],
        {
          cancelable: true
        }
      );
    }
  }


  async function confirmRemoveItem(id) {

    try {

      setLoading(true);

      const responseApi = await fetch(
        `${OPERATIONS_API_BASE}/despesaItem/` + id,
        {
          method: 'DELETE',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      );

      console.log(
        'REMOVER ITEM STATUS:',
        responseApi.status
      );

      if (!responseApi.ok) {

        if (Platform.OS === 'web') {
          window.alert(
            'Não foi possível remover a despesa.'
          );
        } else {
          Alert.alert(
            'Erro',
            'Não foi possível remover a despesa.'
          );
        }

        return;
      }

      await loadItens();

    } catch (error) {

      console.error(
        'ERRO AO REMOVER ITEM:',
        error
      );

      if (Platform.OS === 'web') {
        window.alert(
          'Erro ao remover a despesa.'
        );
      } else {
        Alert.alert(
          'Erro',
          'Erro ao remover a despesa.'
        );
      }

    } finally {

      setLoading(false);
    }
  }

  async function confirmSubmit() {

    try {

      setLoading(true);

      /*
      * Busca todos os itens do relatório para verificar
      * se existe algum item sem foto do recibo / NF.
      */
      const response = await fetch(
        `${OPERATIONS_API_BASE}/despesaItem/despesa/` + despesaId
      );

      const data = await response.json();

      console.log(
        'ITENS ANTES DO ENVIO:',
        data
      );

      if (!response.ok) {
        throw new Error(
          'Erro ao consultar itens da despesa'
        );
      }

      let stopSubmit = false;

      if (Array.isArray(data)) {

        data.forEach((item) => {

          if (
            item.foto == null ||
            item.foto === ''
          ) {
            stopSubmit = true;
          }

        });
      }

      /*
      * No navegador, Alert.alert não funciona corretamente.
      */
      if (stopSubmit) {

        if (Platform.OS === 'web') {

          window.alert(
            'Existem itens sem fotos do recibo / NF, favor verificar.'
          );

        } else {

          Alert.alert(
            'Atenção',
            'Existem itens sem fotos do recibo / NF, favor verificar',
            [
              {
                text: 'Fechar',
                style: 'cancel'
              }
            ],
            {
              cancelable: false
            }
          );
        }

        return;
      }

      /*
      * Altera o relatório de Rascunho (0)
      * para Aguardando Aprovação (1).
      */
      const responseApi = await fetch(
        `${OPERATIONS_API_BASE}/despesa/` + despesaId,
        {
          method: 'PUT',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            status: 1
          }),
        }
      );

      const dataPut = await responseApi.json();

      console.log(
        'ENVIAR APROVAÇÃO STATUS:',
        responseApi.status
      );

      console.log(
        'ENVIAR APROVAÇÃO RESPONSE:',
        dataPut
      );

      if (!responseApi.ok) {

        if (Platform.OS === 'web') {

          window.alert(
            'Não foi possível enviar o relatório para aprovação.'
          );

        } else {

          Alert.alert(
            'Erro',
            'Não foi possível enviar o relatório para aprovação.'
          );
        }

        return;
      }

      /*
      * Sucesso
      */
      if (Platform.OS === 'web') {

        window.alert(
          'Relatório de Despesas enviado com sucesso!'
        );

        navigation.navigate('Home');

      } else {

        Alert.alert(
          'Sucesso',
          'Relatório de Despesas enviado com sucesso!',
          [
            {
              text: 'Fechar',
              onPress: () =>
                navigation.navigate('Home')
            }
          ],
          {
            cancelable: false
          }
        );
      }

    } catch (error) {

      console.error(
        'ERRO AO ENVIAR PARA APROVAÇÃO:',
        error
      );

      if (Platform.OS === 'web') {

        window.alert(
          'Erro ao enviar o relatório para aprovação.'
        );

      } else {

        Alert.alert(
          'Erro',
          'Erro ao enviar o relatório para aprovação.'
        );
      }

    } finally {

      setLoading(false);
    }
  }

  function aprovar() {

    if (Platform.OS === 'web') {

      const confirmou = window.confirm(
        'Você confirma a aprovação do relatório de despesas ?'
      );

      if (confirmou) {
        confirmAprovar();
      }

    } else {

      Alert.alert(
        'Confirmar',
        'Você confirma a aprovação do relatório de despesas ?',
        [
          {
            text: 'Sim',
            onPress: () => confirmAprovar()
          },
          {
            text: 'Cancelar'
          }
        ],
        {
          cancelable: true
        }
      );
    }
  }


  async function confirmAprovar() {

    try {

      const responseApi = await fetch(
        `${OPERATIONS_API_BASE}/despesa/` + despesaId,
        {
          method: 'PUT',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            status: 2,
            idaprovador: userid,
            nomeaprovador: usernome,
          }),
        }
      );

      const dataPut = await responseApi.json();

      console.log('APROVAR STATUS:', responseApi.status);
      console.log('APROVAR RESPONSE:', dataPut);

      if (responseApi.ok) {

        if (Platform.OS === 'web') {

          window.alert(
            'Relatório de Despesas aprovado!'
          );

          navigation.navigate('Home');

        } else {

          Alert.alert(
            'Sucesso',
            'Relatório de Despesas aprovado!',
            [
              {
                text: 'Fechar',
                onPress: () => navigation.navigate('Home'),
                style: 'cancel',
              },
            ],
            {
              cancelable: false
            }
          );
        }

      } else {

        alert(
          'Erro ao aprovar relatório: ' +
          JSON.stringify(dataPut)
        );
      }

    } catch (error) {

      console.error(
        'ERRO AO APROVAR DESPESA:',
        error
      );

      if (Platform.OS === 'web') {
        window.alert(
          'Erro ao aprovar relatório de despesas.'
        );
      } else {
        Alert.alert(
          'Erro',
          'Erro ao aprovar relatório de despesas.'
        );
      }
    }
  }

  async function rejeitar() {

    // Primeiro clique: mostra o campo para informar o motivo
    if (!rejectAction) {
      setRejectAction(true);
      return;
    }

    // Depois que o campo estiver visível,
    // exige o preenchimento do motivo
    if (!motivo || motivo.trim() === '') {

      if (Platform.OS === 'web') {
        window.alert(
          'Informe o motivo da rejeição.'
        );
      } else {
        Alert.alert(
          'Atenção',
          'Informe o motivo da rejeição.'
        );
      }

      return;
    }

    // Confirmação no navegador
    if (Platform.OS === 'web') {

      const confirmou = window.confirm(
        'Você confirma a rejeição do relatório de despesas?'
      );

      if (confirmou) {
        await confirmRejeitar(motivo.trim());
      }

    } else {

      Alert.alert(
        'Confirmar',
        'Você confirma a rejeição do relatório de despesas?',
        [
          {
            text: 'Sim',
            onPress: () =>
              confirmRejeitar(motivo.trim())
          },
          {
            text: 'Cancelar',
            style: 'cancel'
          }
        ],
        {
          cancelable: true
        }
      );
    }
  }


  async function confirmRejeitar(motivoRejeicao) {

    try {

      setLoading(true);

      const responseApi = await fetch(
        `${OPERATIONS_API_BASE}/despesa/` + despesaId,
        {
          method: 'PUT',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            status: 3,
            idaprovador: userid,
            nomeaprovador: usernome,
            commaprovador: motivoRejeicao
          }),
        }
      );

      const dataPut = await responseApi.json();

      console.log(
        'REJEITAR STATUS:',
        responseApi.status
      );

      console.log(
        'REJEITAR RESPONSE:',
        dataPut
      );

      if (!responseApi.ok) {

        if (Platform.OS === 'web') {
          window.alert(
            'Erro ao rejeitar o relatório.'
          );
        } else {
          Alert.alert(
            'Erro',
            'Erro ao rejeitar o relatório.'
          );
        }

        return;
      }

      if (Platform.OS === 'web') {

        window.alert(
          'Relatório de Despesas rejeitado!'
        );

        navigation.navigate('Home');

      } else {

        Alert.alert(
          'Sucesso',
          'Relatório de Despesas rejeitado!',
          [
            {
              text: 'Fechar',
              onPress: () =>
                navigation.navigate('Home')
            }
          ],
          {
            cancelable: false
          }
        );
      }

    } catch (error) {

      console.error(
        'ERRO AO REJEITAR DESPESA:',
        error
      );

      if (Platform.OS === 'web') {
        window.alert(
          'Erro ao rejeitar relatório de despesas.'
        );
      } else {
        Alert.alert(
          'Erro',
          'Erro ao rejeitar relatório de despesas.'
        );
      }

    } finally {

      setLoading(false);
    }
  }

  
  useEffect(() => {
    setLoading(true);
    loadHeader();
    loadItens();
    getStorageValue();
  }, []);

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === "ios" ? "padding" : "height"}
      style={styles.container}
    >
      <ScrollView keyboardShouldPersistTaps="handled" contentContainerStyle={styles.scrollContent}>
        {loading && (
          <ActivityIndicator
            size="large"
            color="#0000ff"
            style={styles.LoadingIndicator}
          />
        )}

        <View>
          <View style={styles.headerContainer}>
            <Text numberOfLines={1} style={styles.textDescBold2}>
              Informações
            </Text>
            {numero != "" &&
              <Text numberOfLines={1} style={styles.textDesc}>
                <Text style={styles.textDescBold}>Número: </Text>
                {numero}
              </Text>
            }
            <Text numberOfLines={1} style={styles.textDesc}>
              <Text style={styles.textDescBold}>Data: </Text>
              {dataEntrada}
            </Text>
            <Text numberOfLines={1} style={styles.textDesc}>
              <Text style={styles.textDescBold}>Requisitante: </Text>
              {status > 0 ? nomerequester : usernome}
            </Text>
            
            <Text numberOfLines={1} style={styles.textDesc}>
              <Text style={styles.textDescBold}>Status: </Text>
              {status == "0"
                ? "Rascunho"
                : status == "1"
                ? "Aguardando Aprovação"
                : status == "2"
                ? "Aprovado"
                : "Reprovado"}
            </Text>
            { status == 1 &&
             <Text numberOfLines={1} style={styles.textDesc}>
              <Text style={styles.textDescBold}>Aprovador: </Text>
              {nomeaprovador}
             </Text>
            }
            { status == 2 &&
              <Text numberOfLines={1} style={styles.textDesc}>
                <Text style={styles.textDescBold}>Aprovado por: </Text>
                {nomeaprovador}
              </Text>
            }
             { status == 3 &&
             <>
              <Text numberOfLines={1} style={styles.textDesc}>
                <Text style={styles.textDescBold}>Rejeitado por: </Text>
                {nomeaprovador}
              </Text>
              <Text numberOfLines={1} style={styles.textDesc}>
                <Text style={styles.textDescBold}>Motivo: </Text>
                {commaprovador} 
              </Text>
            </>
            }

        { (status == 0 || comments != "") &&
          <>
            <Text style={styles.textDescBold}>Observação:</Text>

          <TextInput
            style={styles.textSearch}
            placeholder={status < 1 ? "Digite suas observações": ""}
            placeholderTextColor="#484848"
            maxLength={200}
            autoCorrect={false}
            editable={status < 1 || status ==  3}
            multiline={true}
            autoCapitalize="sentences"
            value={comments}
            onChangeText={setComments}
          />
        </>

        }
          </View>
        </View>
        
        {(status == 0 || status == 3) && 
          <View>
            <TouchableHighlight
              underlayColor={"#d8d8d8"}
              style={styles.headerContainerInt}
              onPress={async () => {
                const despesaDocId = await saveOnly(false, false);
                setDespesaId(despesaDocId);
                navigation.navigate({
                  name: "DespesaItem", 
                  params: {despesaId: despesaDocId, 
                  status: status, 
                  refresh: loadItens, 
                  updateDespesa: setDespesaId 
                }
              });
              }}
            >
              <View style={styles.buttonDone}>
                <Text style={styles.buttonTextBig}>+</Text>
              </View>
            </TouchableHighlight>
          </View>
        }
        {itens.map((item, indexe) => (
          <TouchableHighlight
            underlayColor={"#a5a5a5"}
            style={styles.highlight}
            key={indexe}
            onPress={() => {
              navigation.navigate({
              name: "DespesaItem",
              params: {id: item._id, 
              status: status, 
              refresh: loadItens }
            });
          }}
          >
            <View style={styles.containerGeral}>
              <View style={styles.txtContainerRow}>
                <View style={styles.divCounter}>
                  <Text numberOfLines={1} style={styles.textDesc}>
                    {item.categoriaText}
                  </Text>
                  <Text numberOfLines={1} style={styles.textDesc}>
                    {item.descr}
                  </Text>
                  <Text numberOfLines={1} style={styles.textDescBold}>
                    R${item.valor}
                  </Text>
                </View>
                {(status < 1 || status == 3) && 
                  <TouchableHighlight style={styles.divIcon} underlayColor={"#d3d3d3"}
                    onPress={() => {
                      removeItem(item._id);
                    }}
                  >
                    <View>
                      <Ionicons name="close" color="#900603" size={20}  />
                    </View>
                  </TouchableHighlight>
                }
                {status > 0 &&
                <View style={styles.divIcon}>
                  <Entypo name={'chevron-right'} style={styles.searchIconReset} size={18} color="#b2b2b2" />  
                </View>
                }
                
               
              </View>
            </View>
          </TouchableHighlight>
        ))}
        
        {itens.length > 0 && 
          <View style={styles.headerContainerInt}>
            <Text numberOfLines={1} style={styles.textDesc}>
              <Text style={styles.textDesc}>Total: <Text style={styles.textDescBold}>{"R$" + itensSum}</Text></Text>
            </Text>
        </View>
       }
        
      {itens.length > 0 && (status == 0 || status == 3) && (
        <View style={styles.actionsContainer}>
          <TouchableHighlight
            style={[styles.actionButtonFull, styles.actionSecondary, loading && styles.actionDisabled]}
            underlayColor="#edf3fb" disabled={loading}
            accessibilityRole="button" accessibilityLabel="Salvar rascunho"
            onPress={() => saveOnly(true, false)}>
            <Text style={[styles.actionText, styles.actionTextPrimary]}>Salvar Rascunho</Text>
          </TouchableHighlight>
          <TouchableHighlight
            style={[styles.actionButtonFull, styles.actionPrimary, loading && styles.actionDisabled]}
            underlayColor="#00004C" disabled={loading}
            accessibilityRole="button" accessibilityLabel="Enviar para aprovação"
            onPress={() => saveOnly(false, true)}>
            <Text style={[styles.actionText, styles.actionTextWhite]}>Enviar para Aprovação</Text>
          </TouchableHighlight>
        </View>
      )}
      {status == 1 && apprdesp == "true" && (
        <View style={styles.actionsContainer}>
          <View style={styles.actionsRow}>
            <TouchableHighlight
              style={[styles.actionButton, styles.actionPrimary, loading && styles.actionDisabled]}
              underlayColor="#00004C" disabled={loading}
              accessibilityRole="button" accessibilityLabel="Aprovar despesa"
              onPress={() => aprovar()}>
              <Text style={[styles.actionText, styles.actionTextWhite]}>Aprovar</Text>
            </TouchableHighlight>
            <TouchableHighlight
              style={[styles.actionButton, styles.actionReject, loading && styles.actionDisabled]}
              underlayColor="#fff0f0" disabled={loading}
              accessibilityRole="button" accessibilityLabel="Rejeitar despesa"
              onPress={() => rejeitar()}>
              <Text style={[styles.actionText, styles.actionTextReject]}>Rejeitar</Text>
            </TouchableHighlight>
          </View>
          {rejectAction == true && (
            <TextInput style={styles.rejectionInput}
              placeholder="Motivo da Rejeição" placeholderTextColor="#63758c"
              accessibilityLabel="Motivo da rejeição"
              maxLength={200} autoCorrect={false}
              value={motivo} onChangeText={setMotivo} multiline/>
          )}
        </View>
      )}
      </ScrollView>
    </KeyboardAvoidingView>

    // <View style={styles.container}>

    //     <View style={styles.containerGeral}>

    //       {/* <TextInput
    //           style={styles.textSearch}
    //           placeholder='Digite suas observações'
    //           placeholderTextColor="gray"
    //           maxLength={200}
    //           multiline={true}
    //           autoCapitalize='sentences'
    //           value={comments}
    //           onChangeText={setComments}
    //         /> */}

    //       {/* <TouchableHighlight underlayColor={"transparent"} onPress={() => { navigation.navigate('Camera') }}>
    //         <View style={styles.menuItem}>
    //           <Text style={styles.textMenu}>Adicionar Foto</Text>
    //         </View>
    //       </TouchableHighlight>

    //       <TouchableHighlight underlayColor={"transparent"} onPress={() => { navigation.navigate('Checklist2Compressor') }}>
    //         <View style={styles.menuItem}>
    //           <Text style={styles.textMenu}>Próximo Item</Text>
    //         </View>
    //       </TouchableHighlight> */}

    //     </View>

    // </View>
  );
}

var styles = createScreenStyles({
  scrollContent: { paddingBottom: 40 },
  actionsContainer: {
    marginTop: 24, marginHorizontal: 12, marginBottom: 12, padding: 16,
    borderRadius: 16, backgroundColor: '#fff', borderWidth: 1, borderColor: '#e1e8f2', gap: 12
  },
  actionsRow: { flexDirection: 'row', flexWrap: 'wrap', gap: 12 },
  actionButton: {
    flexGrow: 1, flexBasis: '45%', minWidth: 120, minHeight: 52,
    paddingHorizontal: 16, paddingVertical: 14, borderRadius: 12,
    alignItems: 'center', justifyContent: 'center'
  },
  actionButtonFull: {
    width: '100%', minHeight: 52, paddingHorizontal: 16, paddingVertical: 14,
    borderRadius: 12, alignItems: 'center', justifyContent: 'center'
  },
  actionPrimary: { backgroundColor: '#003c84' },
  actionSecondary: { backgroundColor: '#fff', borderWidth: 1, borderColor: '#003c84' },
  actionReject: { backgroundColor: '#fff', borderWidth: 1, borderColor: '#a80101' },
  actionDisabled: { opacity: 0.5 },
  actionText: { fontSize: 16, lineHeight: 22, fontWeight: '600', textAlign: 'center' },
  actionTextWhite: { color: '#fff' },
  actionTextPrimary: { color: '#003c84' },
  actionTextReject: { color: '#a80101' },
  rejectionInput: {
    width: '100%', minHeight: 100, borderWidth: 1, borderColor: '#d9e3f0',
    borderRadius: 12, padding: 12, fontSize: 16, textAlignVertical: 'top', color: '#172b4d'
  },
  container: {
    flex: 1,
    backgroundColor: "#d5d5d5",
  },

  LoadingIndicator: {
    flex: 1,
    justifyContent: "center",
    marginTop: 15,
  },

  ItemImg: {
    backgroundColor: "#fff",
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 4,
    marginLeft: screenWidth * 0.025,
    marginRight: screenWidth * 0.025,
  },

  menuItem: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "green",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  menuItemG: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "green",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  menuItemY: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "#CC6600",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  row:{
    marginTop:30,
    marginLeft:5,
    marginRight:5,
    paddingTop:15,
    paddingBottom:15,
    flexDirection:'row',
    flex:1,
    flexWrap:'wrap',
    backgroundColor:'#fff'
  },

  menuItemR: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "red",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  textDescPend: {
    fontSize: 14,
    paddingTop: 5,
    fontWeight: "bold",
    color: "#fa9200",
  },

  textDescOk: {
    fontSize: 14,
    paddingTop: 5,
    fontWeight: "bold",
    color: "#4ead31",
  },

  textMenu: {
    color: "#fff",
    fontSize: 16,
  },

  textSearch: {
    width: '92%',
    paddingLeft: 10,
    color: "#484848",
    height: 50,
    marginTop: screenHeight * 0.01,
    marginBottom: screenHeight * 0.01,
    backgroundColor: "#fff",
    borderColor: "#d3d3d3",
    borderWidth: 1,
    borderRadius: 5,
  },

  textMotivo: {
    width: '92%',
    paddingLeft: 10,
    color: "#484848",
    height: 50,
    marginTop: screenHeight * 0.01,
    marginBottom: screenHeight * 0.01,
    marginLeft: screenWidth * 0.025,
    backgroundColor: "#fff",
    borderColor: "#d3d3d3",
    borderWidth: 1,
    borderRadius: 5,
  },

  textEmpty: {
    fontSize: 14,
    fontWeight: "300",
    color: "#484848",
    marginLeft: screenWidth * 0.025,
    marginTop: 10,
    textAlign: "center",
  },

  textDesc: {
    fontSize: 14,
    paddingTop: 5,
  },

  textDescBold: {
    fontSize: 14,
    paddingTop: 5,
    fontWeight: "bold",
  },

  textDescBoldObs: {
    fontSize: 14,
    paddingTop: 15,
    fontWeight: "bold",
    paddingLeft: 10,
  },

  textDescBold2: {
    fontSize: 14,
    marginBottom: 5,
    fontWeight: "bold",
    textAlign: "center",
  },

  textDescBold3: {
    fontSize: 15,
    marginBottom: 5,
    fontWeight: "bold",
    textAlign: "center",
    color: "#484848",
  },

  textDescAberto: {
    fontSize: 12,
    paddingTop: 5,
    color: "green",
  },

  containerGeral: {
    backgroundColor: "#fff",
    paddingLeft: 10,
    paddingBottom: 10,
    borderRadius: 3,
  },

  txtContainer: {
    width: '90%',
    marginTop: 5,
  },

  txtContainerRow: {
    flexDirection: "row",
    marginTop: 5,
  },

  headerContainerInt: {
    marginTop: 5,
    marginLeft: 0,
    marginRight: 5,
    padding: 10,
    alignItems: "flex-end"
  },

  headerContainerIntBtn: {
    marginTop: 5,
    marginLeft: 0,
    marginRight: 5,
    padding: 10
  },

  headerContainer: {
    backgroundColor: "#fff",
    marginTop: 5,
    marginLeft: 5,
    marginRight: 5,
    padding: 10,
  },

  highlight: {
    marginTop: 5,
    marginLeft: 5,
    marginRight: 5,
    borderWidth: 1,
    borderColor: "#999999",
  },

  buttonDoneBig: {
    backgroundColor: "darkblue",
    marginTop: 5,
    marginRight:5,
    marginLeft:10,
    height: 60,
    width: '44%',
    justifyContent: "center",
    borderRadius: 10,
  },

  buttonDone: {
    backgroundColor: "darkblue",
    marginTop: 5,
    height: 50,
    width: '15%',
    justifyContent: "center",
    borderRadius: 5
  },

  buttonPend: {
    backgroundColor: "#993333",
    marginTop: 5,
    height: 30,
    width: '90%',
    justifyContent: "center",
  },

  buttonText: {
    textAlign: "center",
    color: "#fff",
  },

  buttonTextBig: {
    textAlign: "center",
    color: "#fff",
    fontSize:18,
    fontWeight: "bold",
  },

  divCounter: {
    width: '85%',
    justifyContent: "center",
    borderRightWidth: 1,
    borderRightColor: "#a1a1a1",
  },

  divMiddle: {
    width: '85%',

    paddingLeft: 10,
  },

  divIcon: {
    width: '9%',
    height:60,
    justifyContent: "center",
    alignSelf: "center",
    alignItems: "center"
  },
});
